import React from 'react';
import { Link, useParams } from 'react-router-dom';
import TvecLayout from '../../components/TvecLayout';
import TvecBreadcrumb from '../../components/TvecBreadcrumb';
import TvecCleaningCharts from '../../components/TvecCleaningCharts';
import TvecDocuments from '../../components/TvecDocuments';
import { PREMISES_PATH, findPremisesItem } from '../../utils/tvecPremises';

// Each area's page. Documents work for every area; its own features are added later.
export default function TvecPremisesItem() {
  const { slug } = useParams();
  const item = findPremisesItem(slug);

  return (
    <TvecLayout title="Premises and Resources">
      <div className="w-full">
        <TvecBreadcrumb
          items={[
            { label: 'TVEC', href: '/tvec/dashboard' },
            { label: 'Premises and Resources', href: PREMISES_PATH },
            { label: item ? item.title : 'Not found' },
          ]}
        />
        {item ? (
          <div className="space-y-5">
            <h2 className="text-lg font-semibold text-slate-900">{item.number}. {item.title}</h2>
            {item.slug === 'cleaning-charts' ? (
              <>
                <TvecCleaningCharts />
                <TvecDocuments
                  section={item.slug}
                  sectionTitle={item.title}
                  heading="Other documents"
                  intro="Any other file for cleaning charts: upload, preview, download or delete. Re-uploading keeps the earlier files in the history."
                />
              </>
            ) : (
              <TvecDocuments section={item.slug} sectionTitle={item.title} />
            )}
          </div>
        ) : (
          <div className="rounded-2xl border border-dashed border-slate-300 bg-white px-4 py-12 text-center">
            <p className="text-sm text-slate-600">This page does not exist.</p>
            <Link to={PREMISES_PATH} className="mt-3 inline-block text-sm font-semibold text-sky-700 hover:underline">Back to Premises and Resources</Link>
          </div>
        )}
      </div>
    </TvecLayout>
  );
}
